import ArtifactGroupType from "../base/ArtifactGroupType";

const VesselOfAthena = {
  id: '100',
  name: 'Vessel Of Athena',
  icon: 'VesselOfAthena',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 10
};

export default VesselOfAthena;
